import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollTopComponent } from './scroll-top.component';
import { AvatarModule } from '../avatar';
import { MaterialModule } from '@lockton-apps/material';
import { ButtonModule } from '../button';

@NgModule({
  declarations: [ScrollTopComponent],
  imports: [CommonModule, AvatarModule, MaterialModule, ButtonModule],
  exports: [ScrollTopComponent],
})
export class ScrollTopModule {}
